<section class="verify-certificate">
    <h1 id="verify-certificate-title">{{title}}</h1>
    <span>{{'verificar-certificado.form.obligatorio' | translate}}</span>
    
    <form [formGroup]="filtersForm">
         
        <div class="entry">
            <label for="csv">{{'verificar-certificado.form.csv' | translate}} *</label>
            <input [ngClass]="{ 'error': showError }" type="text" id="csv" formControlName="csv">
        </div>

        <div class="buttons">
             <button (click)="resetForm()" class="secondary" title="{{'verificar-certificado.botones.limpiar' | translate}}">
                {{'verificar-certificado.botones.limpiar' | translate}}
             </button>
             <button (click)="validateForm()" title="{{'verificar-certificado.botones.mostrarDocumento' | translate}}">
                {{'verificar-certificado.botones.mostrarDocumento' | translate}}
             </button>
        </div>
    </form>

    <p *ngIf="showNoDocText">{{'verificar-certificado.error.carga' | translate}}</p>

    <div *ngIf="certificateSrc">
        <iframe allowfullscreen [src]="certificateSrc"></iframe>
    </div>

    <div class="buttons close" *ngIf="certificateSrc">
        <button (click)="closeCertificate()" class="button" title="{{'verificar-certificado.botones.cerrar' | translate}}">
        {{'verificar-certificado.botones.cerrar' | translate}}
        </button>
    </div>

    <app-spinner *ngIf="showSpinner"></app-spinner>
</section>